<template>
    <div class="right-modules-container">
        <ul>
            <li v-for="(index, i) in moduleList" :key="i">
                <!-- <LoginComponent v-if="index==0" :columnId="columnId" :columnName="columnName"></LoginComponent> -->
                <RecommendBulletin v-if="index==1 && bulletinList.length > 0"></RecommendBulletin>
                <!-- <ReporterComponent v-if="index==2" :columnId="columnId" :columnName="columnName"></ReporterComponent> -->
                <!-- <HotLabel v-if="index==3" :columnId="columnId" :columnName="columnName"></HotLabel> -->
                <HotArticle v-if="index==4 && hotArticleList.length > 0"></HotArticle>
                <!-- <BlogrollComponent v-if="index==5" :columnId="columnId" :columnName="columnName"></BlogrollComponent> -->
                <VideoArea v-if="index==6 && videoList.length > 0"></VideoArea>
                <QrCode v-if="index==7"></QrCode>
                <!-- <QrCodeHot v-if="index==8" :columnId="columnId" :columnName="columnName" :qrcode="qrcode"></QrCodeHot> -->
                <!-- <MoneyCode v-if="index==9" :columnId="columnId" :columnName="columnName"></MoneyCode> -->
                <ColumnRecommend v-if="index==10 && mpwxList.length > 0"></ColumnRecommend>
            </li>
        </ul>
    </div>
</template>
<script>
// 登录组件-index: 0
import LoginComponent from '@/components/pc/common/login/LoginComponent.vue';
// 推荐快报-index: 1
import RecommendBulletin from '@/components/pc/common/recommend-bulletin/RecommendBulletin.vue';
// 记者专栏-index: 2
import ReporterComponent from '@/components/pc/common/reporter/ReporterComponent.vue';
// 热门标签-index: 3
import HotLabel from '@/components/pc/common/hot-label/HotLabel.vue';
// 热门文章-index: 4
import HotArticle from '@/components/pc/common/hot-article/HotArticle.vue';
// 友情链接-index: 5
import BlogrollComponent from '@/components/pc/common/blogroll/BlogrollComponent.vue';
// 视频区-index: 6
import VideoArea from '@/components/pc/common/video-area/VideoArea.vue';
// 二维码-index: 7
import QrCode from '@/components/pc/common/qr-code/QrCode.vue';
// 二维码-热门公众号推荐-8
import QrCodeHot from '@/components/pc/common/qr-code/QrCodeHot.vue';
// 二维码-分钱码-9
import MoneyCode from '@/components/pc/common/qr-code/MoneyCode.vue';
// 栏目推荐-10
import ColumnRecommend from '@/components/pc/common/right-modules/column-recommend/ColumnRecommend.vue';
export default {
    name: 'RightModules',
    props: ['modules', 'columnId', 'columnName', 'columnInfo', 'qrcode'],
    data() {
        return {
            moduleList: []
        }
    },
    components: {
        LoginComponent,
        RecommendBulletin,
        ReporterComponent,
        HotLabel,
        HotArticle,
        BlogrollComponent,
        VideoArea,
        QrCode,
        QrCodeHot,
        MoneyCode,
        ColumnRecommend
    },
    computed: {
        // 热门转发
        bulletinList() {
            return this.$store.state.articleModules.hotTranspondList;
        },
        // 热门文章
        hotArticleList() {
            return this.$store.state.articleModules.hotList;
        },
        // 转发推荐
        videoList() {
            return this.$store.state.articleModules.transRecomList;
        },
        // 托管公众号
        mpwxList() {
            return this.$store.state.articleModules.mpwxTrusteeshipList;
        }
    },
    created() {
        this.getModuleList();
    },
    methods: {
        getModuleList() {
            this.moduleList = this.modules;
            // if(this.modules.length > 0) {

            // }
        }
    }
}
</script>
<style lang="scss" scoped>
@import './RightModules.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/right-modules/RightModules.vue